export enum OrderFlow {
  cancel = 'cancel',
  report = 'report',
  return = 'return',
  track = 'track',
}

export const SSP_BASE_PATH = '/ssp';

export function getOrdersPath() {
  return `${SSP_BASE_PATH}/orders`;
}

export function getPathToOrderDetailsPage(orderId: string | number): string {
  return `${getOrdersPath()}/${orderId}`;
}

export function getSspLoginPath() {
  return `${SSP_BASE_PATH}/login`;
}

type FlowUrlParams = {
  orderId: string | number;
  fulfillmentId: string | number;
};

export function getOrderFlowPath(flow: OrderFlow, params: FlowUrlParams) {
  return `${SSP_BASE_PATH}/order/${flow}/${params.orderId}/${params.fulfillmentId}`;
}
